import { render, staticRenderFns } from "./modal-feedback.vue?vue&type=template&id=698f7ace&scoped=true"
import script from "./modal-feedback.vue?vue&type=script&lang=js"
export * from "./modal-feedback.vue?vue&type=script&lang=js"
import style0 from "./modal-feedback.vue?vue&type=style&index=0&id=698f7ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f7ace",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseButton.vue').default})
